<ng-container *ngIf="systemValues$ | async as sysVal">
  <ng-container *ngIf="currentSession$ | async as session">
    <ng-container *ngIf="!!session.UserId">
      <div class="layout-container" [ngClass]="isAuthPage ? 'auth-bg' : 'default-bg'">

        <!-- Main Content -->
        <div class="main-content-container">
          <header class="header px-3">
            <nav class="navbar px-2">
              <div class="d-flex">
                <a class="home-icon" role="button" aria-label="Return to Home" (click)="onClickHome()"
                  *ngIf="isHomeButtonShown" title="Return to Home">
                  <mat-icon class="material-symbols-outlined" aria-hidden="true" style="margin-bottom: -3px;">home
                  </mat-icon>
                </a>
                <h1 class="PageTitle ms-3">
                  <ng-container *ngFor="let part of pageTitle; let i = index">
                    <span *ngIf="!navigationBreadCrumbs.has(part)" [innerHTML]="part | safeHtml" class="breadcrumb-item"
                      [title]="part"></span>

                    <span *ngIf="navigationBreadCrumbs.has(part) && i == 0" [innerHTML]="part | safeHtml"></span>
                    <a *ngIf="navigationBreadCrumbs.has(part) && i != 0" class="breadcrumb-link"
                      (click)="onBreadcrumbClick(i)">
                      {{ part }}
                    </a>

                    <span *ngIf="i < pageTitle.length - 1"> | </span>
                  </ng-container>
                </h1>
              </div>
              <!-- Page Dropdown -->
              <ul class="nav-links">
                <eap-quick-search></eap-quick-search>
                <eap-dropdown behavior="navigate" [placeholder]="currentUser.UserName"
                  selectedLabel="FirstName, LastName" [options]="pages" [allowToShowPlaceHolder]="true"
                  [isInputReadOnly]="true"></eap-dropdown>
              </ul>
            </nav>
          </header>

          <main class="main-content mx-3">
            <div class="router-outlet-wrapper">
              <router-outlet></router-outlet>
            </div>
          </main>
        </div>
        <!-- </mat-drawer-container> -->
      </div>
    </ng-container>
  </ng-container>
</ng-container>